import { gql, TypedDocumentNode } from "@apollo/client";

export const GET_SPACELIFT_AWS_ACCOUNT_ID: TypedDocumentNode<{ spaceliftAwsAccountId: string }> =
  gql`
    query GetSpaceliftAwsAccountId {
      spaceliftAwsAccountId
    }
  `;
